import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const ICON_SIDE = 60;

const style = () => {
  const { colorIconSuccess, colorBgBase } = theme();

  const styles = StyleSheet.create({
    icon: {
      height: ICON_SIDE,
      width: ICON_SIDE,
    },
  });

  return {
    ...styles,
    colorBgBase,
    colorIconSuccess,
  };
};

export { style };
